import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedData } from '../models/BaseResponse';
import { Locality } from '../models/Locality';
import { LocalitySearchCriteria } from '../models/searchCriteria/LocalitySearchCriteria';

@Injectable({
  providedIn: 'root'
})
export class LocalityService {


  constructor(private httpClient: HttpClient) { }

  find(searchCriteria: LocalitySearchCriteria): Observable<PagedData<Locality>> {
    return this.httpClient.post<PagedData<Locality>>(environment.apiUrl + "localities/filtered", searchCriteria);
  }

  get(id: number): Observable<Locality> {
    return this.httpClient.get<Locality>(environment.apiUrl + "localities/" + id);
  }

  save(locality: Locality): Observable<void> {
    return this.httpClient.post<void>(environment.apiUrl + "localities", locality);
  }

  delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(environment.apiUrl + "localities/" + id);
  }
}
